import { Suspense } from 'react'

import { ErrorBoundary } from '../../common/components/ErrorBoundary/ErrorBoundary.js'

import { CookieConsentProvider } from './CookieConsentProvider.js'

export const CookieConsentWrapper = ({
  children,
}: {
  children: React.ReactNode
}) => {
  return (
    <ErrorBoundary>
      <Suspense fallback={<></>}>
        <CookieConsentProvider>{children}</CookieConsentProvider>
      </Suspense>
    </ErrorBoundary>
  )
}
